var cookieApprovalModal = $('#cookie-approval');

var googleAnalyticsID = $('body').data('gacode');
var googleRemarketingID = $('body').data('grcode');
var facebookPixelID = $('body').data('fbpcode');


window.dataLayer = window.dataLayer || [];

$(document).ready(function () {


    var approvalState = Cookies.get('cookie_approval');


    var cookiePath = window.location.host.split('.').reverse();
    cookiePath = '.' + cookiePath[1] + '.' + cookiePath[0];


    if (typeof approvalState == 'undefined' || approvalState == 'revoked') {
        cookieApprovalModal.modal({
            'show': true,
            'backdrop': 'static',
            'keyboard': false
        });
    }

    if (approvalState == 'allow') {

        if (typeof googleAnalyticsID != 'undefined') {
            Cookies.set('ga-disable-' + googleAnalyticsID, false, {expires: 7, secure: true, sameSite: 'strict'});
            // Send tracking if ID is set
            if (googleAnalyticsID.trim() != '') {
                gtag('js', new Date());
                gtag('config', googleAnalyticsID, {'anonymize_ip': true});
            }
        }

        if (typeof googleRemarketingID != 'undefined') {
            // Send remarketing if ID is set
            if (googleRemarketingID.trim() != '') {
                gtag('js', new Date());
                gtag('config', googleRemarketingID);
                gtag('set', 'allow_ad_personalization_signals', true);
            }
        }
        if (typeof facebookPixelID != 'undefined') {
            Cookies.set('fp-disable-mde-service', false, {expires: 7, secure: true, sameSite: 'strict'});
            // Send tracking if ID is set
            if (facebookPixelID.toString().trim() != '') {
                fbq('init', facebookPixelID);
                fbq('track', 'PageView');
            }
        }

    }

    if (approvalState == 'revoked') {
        console.log('Entscheidung wurde noch nicht getroffen. Tue erstmal nichts!');
    }

    if (approvalState == 'disallow') {

        if (typeof googleRemarketingID != 'undefined') {
            gtag('set', 'allow_ad_personalization_signals', false);
        }

        if (typeof googleAnalyticsID != 'undefined') {
            Cookies.set('ga-disable-' + googleAnalyticsID, true, {expires: 7, secure: true, sameSite: 'strict'});
        }

        if (typeof facebookPixelID != 'undefined') {
            Cookies.set('fp-disable-mde-service', true, {expires: 7, secure: true, sameSite: 'strict'});
        }

        Cookies.remove('_ga', {
            path: '/',
            domain: cookiePath
        });

        Cookies.remove('_gid', {
            path: '/',
            domain: cookiePath
        });

        Cookies.remove('_gat_gtag_' + googleAnalyticsID.replace(/-/g, '_'), {
            path: '/',
            domain: cookiePath
        });

        Cookies.remove('_fbp', {
            path: '/',
            domain: cookiePath
        });
    }


});

function gtag() {
    dataLayer.push(arguments);
}


$('#cookie-approval-disallow').on('click', function (event) {
    event.preventDefault();
    Cookies.set('cookie_approval', 'disallow', {expires: 7, secure: true, sameSite: 'strict'});
    cookieApprovalModal.modal('hide');
    location.reload();
});

$('#cookie-approval-revoke').on('click', function (event) {
    event.preventDefault();
    Cookies.set('cookie_approval', 'revoked', {expires: 7, secure: true, sameSite: 'strict'});
    cookieApprovalModal.modal({
        'show': true,
        'backdrop': 'static',
        'keyboard': false
    });
});

$('#cookie-approval-allow').on('click', function (event) {
    event.preventDefault();
    Cookies.set('cookie_approval', 'allow', {expires: 7, secure: true, sameSite: 'strict'});
    cookieApprovalModal.modal('hide');
    location.reload();
});



// WEBPACK FOOTER //
// ./src/js/cookie-approval.js